var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcAboutUsMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cagqrcdiea",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q6b16j9j9b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#cagqrcdiea)",
    d: "M20 10c0 5.524-4.477 10-10 10S0 15.524 0 10C0 4.478 4.477 0 10 0s10 4.478 10 10",
    transform: "translate(-24 -250) translate(-1) translate(25 115) translate(0 135)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#q6b16j9j9b)",
    d: "M9.995 12.929c.493 0 .885.393.885.875s-.392.875-.875.875c-.485 0-.88-.393-.88-.875s.391-.875.87-.875zm0-7.593c.482 0 .875.393.875.875v4.42c0 .482-.393.875-.875.875s-.875-.393-.875-.875V6.21c0-.482.393-.875.875-.875z",
    transform: "translate(-24 -250) translate(-1) translate(25 115) translate(0 135)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcAboutUsMenu);
export default __webpack_public_path__ + "static/media/icon-ic-about-us-menu.a220ca7c.svg";
export { ForwardRef as ReactComponent };